/**
 * "This is a demo" — plan §6.13.
 *
 * Persistent and above everything, like the support banner, and for a
 * neighbouring reason: the state of the account is not obvious from anything
 * on the screen. Everything in here looks and behaves like the real product —
 * which is the point — so the one thing that has to be unmissable is that
 * none of it is real and none of it will be here later.
 *
 * It says the two things somebody in a demo actually needs: nothing leaves the
 * building, and this copy goes away when they do.
 */
import type { MeResponse } from '@rowted/shared'

type Demo = NonNullable<MeResponse['demo']>

export function DemoBanner({ demo }: { demo: Demo }) {
  const hours = Math.round(demo.idleMinutes / 60)
  const gone = demo.idleMinutes >= 60
    ? `${hours} ${hours === 1 ? 'hour' : 'hours'}`
    : `${demo.idleMinutes} minutes`

  return (
    <div
      role="status"
      data-demo-banner
      className="flex shrink-0 flex-wrap items-center gap-x-2 gap-y-1 border-b border-info
                 bg-info-bg px-4 py-1.5 text-cell text-info"
    >
      <span className="font-semibold">This is a demo</span>
      <span className="text-info/80">
        · Your own copy of a real company&rsquo;s world. Nothing emails, texts or charges
        anybody, and this copy is thrown away when you sign out or after {gone} of quiet.
      </span>
    </div>
  )
}
